import { render } from "./BoardCounsel.vue?vue&type=template&id=963f3c6e"
import script from "./BoardCounsel.vue?vue&type=script&lang=js"
export * from "./BoardCounsel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__